import { GET_SEARCH_RESULTS, SET_SEARCH_KEYWORD } from "../../constants/SearchConstants";

import { SUCCESS } from "../../constants/BaseConstants";

const initialState: SearchStateType = {
    results: [],
    keyword: "",
    isSearching: false
};

export default (state = initialState, action: any) => {
    switch (action.type) {
        case SET_SEARCH_KEYWORD:
            return {
                ...state,
                keyword: action.keyword
            };
        case GET_SEARCH_RESULTS:
            return { ...state, isSearching: true };
        case GET_SEARCH_RESULTS + SUCCESS:
            return {
                ...state,
                results: action.results,
                isSearching: initialState.isSearching
            };
        default:
            return state;
    }
};
